import React from 'react';

import { StyledBackToTop } from './BackToTop.styles';

import { BackToTopProps } from './BackToTop.types';

const BackToTop = ({
  children,
  scrollToOptions = { top: 0, behavior: 'smooth' },
  elementRef,
  scrollIntoViewOptions = { block: 'start', behavior: 'smooth' },
  componentClassname = 'back-to-top',
  customClassnames = '',
  customStyle = '',
  ...props
}: BackToTopProps) => {
  const handleClick = () =>
    elementRef?.current
      ? elementRef.current.scrollIntoView(scrollIntoViewOptions)
      : window.scrollTo(scrollToOptions);

  return (
    <StyledBackToTop
      onClick={handleClick}
      onKeyDown={handleClick}
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      {children}
    </StyledBackToTop>
  );
};
BackToTop.displayName = 'BackToTop';

export default BackToTop;
